import BankCodeInput from "./bankCodeInput";

export default class BikInput<TTarget> extends BankCodeInput<TTarget> {
  // BIK = The BIK is 9 digits code always beginning with 04.
  protected mask = ["0", "4", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
}
